module.exports = __webpack_public_path__ + "media/games-4.87991528.mp4";